// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"838":"6fc14422","936":"40d3cd6c"}[chunkId] + ".js";
};